<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT PENETAPAN GAJI KUP YANG DI LULUSKAN</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="AmaunTelahTerima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Dalam Buku Servis:</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='2'>
                            <base-input type="text" v-model="Obj.AmaunTelahTerima"  />
                             
                        </b-col>
                    </b-row>
                </validation-provider>
                
                <validation-provider name="Amaun Gaji Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Gaji KUP Yang Diluluskan</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='2'>
                            <b-form-input v-model="Obj.SalAmt" :state="getValidation(validationContext)"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Catatan</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='8'>
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Sila isi No. Rujukan surat dan Tarikh Surat Kelulusan JPA."></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col sm="3"> Tarikh Kuatkuasa * (Merujuk kepada Tarikh Kenaikan Pangkat / Pelarasan Gaji SSPA)</b-col>
                        <b-col sm="1">:</b-col>
                        <b-col sm="3">
                            <base-input type="date" v-model="Obj.EftDate" />
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {
            Obj: {
                Catatan: `Gaji KUP yang diluluskan`
            },
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        SimpanMaklumat() {
            swal.fire({
                            title: "PERINGATAN",
                            text: "Sila isi No. Rujukan surat dan Tarikh Surat Kelulusan JPA.",
                        }).then(()=>{
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemenKUPLulus(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        });
        }

    },
    created() {

    }
}
</script>
